/**
 * Centralized cache timing constants for TanStack Query.
 *
 * staleTime: How long data is considered fresh (won't refetch in background)
 * gcTime: How long inactive data stays in cache before garbage collection
 */

/** 30 seconds in milliseconds */
export const THIRTY_SECONDS = 30 * 1000;

/** 2 minutes in milliseconds */
export const TWO_MINUTES = 2 * 60 * 1000;

/** 5 minutes in milliseconds */
export const FIVE_MINUTES = 5 * 60 * 1000;

/** 10 minutes in milliseconds */
export const TEN_MINUTES = 10 * 60 * 1000;

/** 30 minutes in milliseconds */
export const THIRTY_MINUTES = 30 * 60 * 1000;

/** 1 hour in milliseconds */
export const ONE_HOUR = 60 * 60 * 1000;

/**
 * Default cache times for different data types.
 * Use these for consistency across query options.
 */
export const CACHE_TIMES = {
  /** For frequently changing data like cart, orders */
  short: {
    staleTime: TWO_MINUTES,
    gcTime: TEN_MINUTES,
  },
  /** For moderately changing data like layout, account */
  medium: {
    staleTime: FIVE_MINUTES,
    gcTime: THIRTY_MINUTES,
  },
  /** For rarely changing data like CMS content */
  long: {
    staleTime: TEN_MINUTES,
    gcTime: ONE_HOUR,
  },
} as const;
